export enum ProductCardType {
  Default = 'default',
  Commercial = 'commercial',
}
